import { ActiveModal } from "../../../shared/enums/active-modal";
import { Action } from "../../../shared/templates/Header/enum";
import { AppAction } from "../reducer";


export const setModalAction = (modal: ActiveModal): AppAction => ({type: Action.SETMODAL, payload: { modal }})

export const setMenuModalAction = (modal: ActiveModal): AppAction => ({
 type: Action.SETMENUMODAL, payload: { modal }})

export const createSetTabAction = (tab: string ) => ({ type: Action.SETTAB, payload: { tab } })

export const createSetRoleAction = (role: string ) => ({ type: Action.SETROLE, payload: { role } })

export const createSetTaModalbAction = (tab: string ) => ({ type: Action.SETTABMODAL, payload: { tab }})


export const createSetTabRoleAction = (role: string ) => ({ type: Action.SETROLETAB, payload: { role } })